var React = require('react');

function LogoShapeTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-8.56718e-06 6.10352e-05L71.2644 5.79201e-05L92.8694 21.3927C99.3903 27.6773 104.549 35.177 108.039 43.446C111.529 51.7149 113.279 60.5841 113.185 69.5261L113.185 195.994L42.5652 195.994C31.2762 195.994 20.4496 191.619 12.467 183.831C4.48452 176.044 -1.33378e-06 165.481 -1.8152e-06 154.467L-8.56718e-06 6.10352e-05Z","fill":"#1C4063"}));
}

LogoShapeTop.defaultProps = {"viewBox":"0 0 114 196"};

module.exports = LogoShapeTop;

LogoShapeTop.default = LogoShapeTop;
